export default __webpack_public_path__ + "static/media/Teamwork.ffa7ae53.png";